import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError, BehaviorSubject } from 'rxjs';
import { catchError, retry, tap } from 'rxjs/operators';
import { ListaPreco } from '../interfaces/lista-preco';
import { ListaPrecoTabela } from '../interfaces/lista-preco-tabela';
import { PageResult } from '../interfaces/page-result';
import { Router } from '@angular/router';
import { Item } from '../interfaces/item';
import { JwtAuthService } from './auth/jwt-auth.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ListaPrecoTabelaService {

  readonly url = `/lista/preco/tabela`;

  lista_preco$: Observable<ListaPreco>;
  lista_preco: ListaPreco;

  lista_preco_tabela$: Observable<ListaPrecoTabela>;
  lista_preco_tabela: ListaPrecoTabela;

  listPrec: ListaPreco;
  listPrecTabela: ListaPrecoTabela;

  item$: Observable<Item>;
  item: Item;

  constructor(
    private http: HttpClient,
    private authService: JwtAuthService,
    private snackBar: MatSnackBar,
    private router: Router) { }

  getTabela(listaId: number, tabelaId: number): Observable<ListaPrecoTabela> {
    return this.http.get<ListaPrecoTabela>(`${this.authService.apiUrl + this.url}/${listaId}/${tabelaId}`)
      .pipe(
        catchError((e) => {
          console.log(e);
          return throwError(e);
        })
      );
  }

  getListaPrecoTabela(listaId: number): Observable<ListaPrecoTabela[]> {
    return this.http.get<ListaPrecoTabela[]>(`${this.authService.apiUrl + this.url}/${listaId}`)
      .pipe(
        tap(l => console.log(l)),
        catchError((e) => {
          console.log(e);
          return throwError(e);
        })
      );
  }

  saveOrUpdateTabela(lista_preco_tabela: ListaPrecoTabela): Observable<ListaPrecoTabela> {
    return this.http.put<ListaPrecoTabela>(`${this.authService.apiUrl + this.url}`, lista_preco_tabela);
  }

  getTabelaPage(listaId: number, page?: number, size?: number, tabelaIds?: number[]): Observable<PageResult<ListaPrecoTabela>> {
    return this.http.get<PageResult<ListaPrecoTabela>>(`${this.authService.apiUrl + this.url}/page/get?listaId=${listaId}&page=${page}&size=${size}&tabelaIds=${tabelaIds ?? -1}`);
  }

  getTabelaList(listaId: number, page?: number, size?: number, tabelaIdsToExclude?: number[]): Observable<ListaPrecoTabela[]> {
    return this.http.get<ListaPrecoTabela[]>(`${this.authService.apiUrl + this.url}/lista/get?listaId=${listaId}&page=${page}&size=${size}&tabelaIds=${tabelaIdsToExclude ?? -1}`);
  }

  getTabelaPageSearch(listaId: number, page?: number, size?: number, search?: string, tabelaIds?: number[]):
   Observable<PageResult<ListaPrecoTabela>> {
    return this.http.get<PageResult<ListaPrecoTabela>>
      (`${this.authService.apiUrl + this.url}/page/get?listaId=${listaId}&page=${page}&size=${size}&search=${search}&tabelaIds=${tabelaIds ?? -1}`);
  }

  deleteCadastroPrecoTab(id: number): Observable<any> {
    return this.http.delete<any>(`${this.authService.apiUrl + this.url}/tabela/${id}`);
  }

}
